export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f36df9a48e561463640ec2daf1085e87448d140e7&name=fetchTypeahead!'